import { CALL_API } from '../middleware/api'

import { updatePermissions } from './permissions.js';

export const MEMBER_REQUEST = 'MEMBER_REQUEST'
export const MEMBER_SUCCESS = 'MEMBER_SUCCESS'
export const MEMBER_FAILURE = 'MEMBER_FAILURE'

export const UPDATE_MEMBER_REQUEST = 'UPDATE_MEMBER_REQUEST'
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS'
export const UPDATE_MEMBER_FAILURE = 'UPDATE_MEMBER_FAILURE'

const fetchMember = (member_no) => ({
	[CALL_API]: {
		types: [ MEMBER_REQUEST, MEMBER_SUCCESS, MEMBER_FAILURE ],
		endpoint: '/members/'+member_no,
		method: 'POST',
		params: {},
		bad_response: 'Error retrieving member data from U-MAS database'
	}
})

export const loadMember = (refresh = false) => (dispatch, getState) => {
	
	const member = getState().member;
	const now = Math.floor(Date.now() / 1000);
	if (member && ((!refresh && member.expires >= now) || member.fetching)) {
		return null
	}
	
	const user = getState().user;
	return dispatch(fetchMember(user.member_no)).then(result => {
		dispatch(updatePermissions());
	});
}
export const updateMember = (member_no, data) => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [ UPDATE_MEMBER_REQUEST, UPDATE_MEMBER_SUCCESS, UPDATE_MEMBER_FAILURE ],
			endpoint: '/members/'+member_no,
			method: 'PUT',
			params: data,
			bad_response: 'Error updating member ' + member_no + ' in U-MAS database'
		}
	}).then(result => {
		dispatch(updatePermissions());
	});
}